import { CardImage, Pricing } from '.';
import classNames from 'classnames';
import { HomePageCardProps } from './types';
import { AppNextLink } from '../app-next-link';
import { useMobileDetect } from '../mobile-detect-context/mobile-detect-provider';
import { getProductURL } from '../navigation/utils/url-helpers';
export const HomePageCard = ({
  pricingProps,
  brand,
  name,
  slug,
  image,
  isLazy,
  type,
  isSalable,
  className = '',
  index,
  showNumber
}: HomePageCardProps) => {
  const {
    isMobile
  } = useMobileDetect();
  const imageSize = isMobile ? 140 : 156;
  return <AppNextLink prefetch={false} href={getProductURL(slug || '')} className={classNames('relative flex h-full w-full flex-col gap-2 rounded border border-border-gray-light bg-surface-solid-0 shadow-sm', className, 'p-1 lg:p-2')} data-sentry-element="AppNextLink" data-sentry-component="HomePageCard" data-sentry-source-file="homepage-card.tsx">
            {showNumber && <div className='absolute right-1 top-1 flex h-4 w-4 items-center justify-center rounded-full bg-black text-caption-10 text-white lg:h-5 lg:w-5 lg:text-caption-10'>
                    {Number(index) + 1}
                </div>}
            <div className='flex grow flex-col gap-1'>
                <CardImage alt={name} image={image} srcSet={{
        desktop: 130,
        mobile: 175
      }} isLazy={isLazy} imageClassName={classNames('aspect-square', 'w-30 lg:w-39 h-30 lg:h-39')} width={imageSize} height={imageSize} data-sentry-element="CardImage" data-sentry-source-file="homepage-card.tsx" />

                <span className='text-caption-12 text-text-darkGray lg:text-body-14'>{brand}</span>

                <h3 className='line-clamp-2 text-caption-12 text-text-black lg:text-body-14'>
                    {name} {type === 'pink-box' && brand}
                </h3>
            </div>
            {isSalable ? <Pricing {...pricingProps} className='mr-auto' isLanding /> : <span className='mr-auto pt-5 text-caption-12 font-medium text-text-black lg:px-5 lg:pt-6 lg:text-body-14'>
                    تمام شد
                </span>}
        </AppNextLink>;
};